import React from 'react'
import Modal from './Modal'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const RevokeApiKeyModal = ({ isOpen, onClose, onConfirm, isLoading, keyName }) => {
  const handleConfirm = () => {
    onConfirm()
  }

  const handleClose = () => {
    // Prevent closing during revocation
    if (isLoading) return
    onClose()
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={handleClose} 
      title="Revoke API Key" 
      size="sm" 
      preventClose={isLoading}
    >
      <div className="text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <ExclamationTriangleIcon className="h-8 w-8 text-red-600" />
        </div>
        
        <h4 className="text-lg font-semibold text-gray-900 mb-2">
          Are you sure you want to revoke this API key?
        </h4>
        
        <div className="bg-gray-50 rounded-lg p-3 mb-4">
          <p className="text-sm font-medium text-gray-700">
            {keyName}
          </p>
        </div>
        
        <p className="text-gray-600 mb-6 text-sm">
          This action cannot be undone. Any applications using this API key will immediately lose access to the service.
        </p>
        
        <div className="bg-yellow-50 rounded-lg p-4 mb-6">
          <div className="flex">
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5" />
            <div className="text-left">
              <h5 className="font-medium text-yellow-800 text-sm mb-1">Warning</h5>
              <p className="text-sm text-yellow-700">
                Make sure to remove this key from any applications or scripts before revoking it.
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={isLoading}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors font-medium disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Revoking...' : 'Revoke API Key'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default RevokeApiKeyModal
